<template>
  <div id="app">
    <header>
      <h1>佶豊訂單管理系統</h1>
      <button v-if="loggedIn" @click="logout" class="logout-btn">登出</button>
    </header>
    <main>
      <router-view :user-authority="userAuthority"></router-view>
    </main>
  </div>
</template>

<script>

import { useFavicon } from '@vueuse/core'
import { computed, shallowRef } from 'vue'

const type = shallowRef('vueuse')

const favicon = computed(() =>
  type.value === 'vue' ? 'vue.png' : 'favicon.ico')

useFavicon(favicon, {
  baseUrl: '/',
  rel: 'icon',
})

export default {
  name: 'App',
  computed: {
    loggedIn() {
      return this.$route.meta.loggedIn || false;
    },
    userAuthority() {
      return this.$route.meta.userAuthority ?? 2;
    }
  },
  methods: {
    async logout() {
      await fetch('/api/logout', { method: 'POST' });
      this.$router.push('/login');
    }
  }
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background-color: #f0f2f5;
  font-family: Arial, sans-serif;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

header {
  background-color: #2c3e50;
  color: white;
  padding: 1rem;
  text-align: center;
  margin-bottom: 20px;
}

header h1 {
  margin: 0;
  font-size: 1.5rem;
}

main {
  min-height: calc(100vh - 100px);
}

.logout-btn {
  position: absolute;
  right: 2rem;
  top: 1.2rem;
  background: transparent;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 1rem;
}
.logout-btn:hover {
  background: #c0392b;
}
</style>
